import { HeadingProps } from "@/components/heading";
import { HazardProps } from "@/components/mobile-card-hazard";

// TODO: break this up into multiple files
// TODO: separate eg styling from content if it makes sense to

type HazardPropsCollection = HazardProps[];

export const Hazards: HazardPropsCollection = [
  {
    id: 0,
    name: "softStory",
    title: "Wooden soft story",
    description:
      "Wooden soft story buildings that haven't been reinforced may be at risk in an earthquake.",
    info: [
      "A wooden soft story building is a structure built before 1978 that contains an open-floor level, such as a garage or retail space, below one or more living spaces.",
      "According to DataSF, there are 4,943 wooden soft story buildings in SF. But not all are at risk!",
      "Some have been retrofitted to reinforce their lower levels and are generally considered earthquake-safe.",
      "Our data doesn't currently include permit history, so some buildings flagged as at risk may have already been upgraded.",
    ],
    link: {
      label: "Soft story dataset",
      url: "https://data.sfgov.org/Housing-and-Buildings/Soft-Story-Properties/beah-shgi/about_data",
    },
    icon: "circle",
    iconColor: "grey.400",
  },
  {
    id: 1,
    name: "liquefaction",
    title: "Liquefaction zones",
    description:
      "These areas are on less stable ground, which can result in shifting or sinking during an earthquake.",
    info: [
      "Liquefaction is a condition where soil turns into a liquid-like state under pressure.",
      "Buildings in liquefaction zones are at risk of sinking, tilting, or collapsing in a major earthquake.",
      "This risk can be lowered with seismic upgrades such as foundation reinforcement or drainage systems.",
    ],
    link: {
      label: "Liquefaction dataset",
      url: "https://data.sfgov.org/Geographic-Locations-and-Boundaries/Soil-Liquefaction-Hazard-Zone/i4t7-35u3/about_data",
    },
    icon: "square",
    iconColor: "orange",
  },
  {
    id: 2,
    name: "tsunami",
    title: "Tsunami zones",
    description:
      "These coastal areas are at risk of flooding and authorities may recommend evacuation in the event of a tsunami.",
    info: [
      "Buildings in tsunami zones could experience flooding from waves generated by a large earthquake.",
      "Typically, buildings located inland from the coast are less at risk in the event of a tsunami.",
      "Building an emergency kit and planning an evacuation route can help coastal residents be prepared for a tsunami.",
    ],
    link: {
      label: "Tsunami dataset",
      url: "https://www.conservation.ca.gov/cgs/tsunami/maps",
    },
    icon: "square",
    iconColor: "tsunamiBlue",
  },
];

export const Info = [
  {
    id: 1,
    name: "preparedness",
    title: "Preparedness",
    textStyle: "bold",
    list: [
      {
        id: 1,
        title: "Ready.gov",
        subtitle: "Earthquake guide",
        url: "https://www.ready.gov/",
      },
      {
        id: 2,
        title: "Earthquake Authority",
        url: "https://www.earthquakeauthority.com/",
      },
      {
        id: 3,
        title: "MyShake app",
        subtitle: "Early warning",
        url: "https://myshake.berkeley.edu/",
      },
    ],
  },
  {
    id: 2,
    name: "services",
    title: "Building retrofit services",
    list: [
      {
        id: 1,
        title: "Find a contractor",
        url: "https://www.californiaresidentialmitigationprogram.com/resources/find-a-contractor/",
      },
    ],
  },
  {
    id: 3,
    name: "grants",
    title: "Retrofit grants",
    list: [
      {
        id: 1,
        title: "Earthquake Brace + Bolt program",
        url: "https://www.californiaresidentialmitigationprogram.com/our-seismic-retrofit-programs/the-retrofits/ebb-retrofit",
      },
      {
        id: 2,
        title: "EarthquakeSoftStory.com",
        url: "https://www.californiaresidentialmitigationprogram.com/our-seismic-retrofit-programs/the-retrofits/ess-retrofit",
      },
    ],
  },
];

type HeadingPropsCollection = Record<string, HeadingProps>;

export const Headings: HeadingPropsCollection = {
  home: {
    text: "How safe is your home in an earthquake?",
    highlight: "How safe ",
    style: {
      color: "white",
      whiteSpace: { base: "normal", md: "pre-line" },
    },
    highlightStyle: { color: "yellow" },
    themeTextStyle: "headerMedium",
  },
  about: {
    text: "Earthquake safety starts with knowledge.\nWe're here to help.",
    highlight: "",
    style: { color: "blue.text", fontWeight: "light" },
    highlightStyle: {},
    themeTextStyle: "headerBig",
  },
};

export const mockAddressHazardData = [
  { exists: false, last_updated: null },
  { exists: true, last_updated: null },
  { exists: false, last_updated: null },
];

export const DataInfoLinks = [
  {
    id: 1,
    name: "softStory",
    label: "Soft Story Dataset",
    url: "https://data.sfgov.org/Housing-and-Buildings/Soft-Story-Properties/beah-shgi/about_data",
  },
  {
    id: 2,
    name: "liquefaction",
    label: "Liquefaction Dataset",
    url: "https://data.sfgov.org/Geographic-Locations-and-Boundaries/Soil-Liquefaction-Hazard-Zone/i4t7-35u3/about_data",
  },
  {
    id: 3,
    name: "tsunami",
    label: "Tsunami Dataset",
    url: "https://www.conservation.ca.gov/cgs/tsunami/maps",
  },
];

export const Teams = [
  { team_id: 1, name: "Project Management" },
  { team_id: 2, name: "UX/UI Design" },
  { team_id: 3, name: "Front End Engineering" },
  { team_id: 4, name: "Back End Engineering" },
  { team_id: 5, name: "Data Science" },
  { team_id: 6, name: "Partnerships" },
];

// TODO: consider adding `active` boolean property and combining `TeamMembers` and `InactiveTeamMembers` into a single array
type TeamMember = {
  user_id: number;
  role: string;
  name: string;
  team_ids: number[];
};

// TODO: figure out order for both active and inactive members (perhaps we need some dates, such as start_date and/or end_date)
// TODO: make this easy to edit, update, order/reorder with some kind of UI?
// TODO: combine into single array (perhaps with `active` boolean property)
export const TeamMembers: TeamMember[] = [
  {
    user_id: 1,
    role: "Project Manager, Data Science",
    name: "Leela Solomon",
    team_ids: [1, 5],
  },
  {
    user_id: 2,
    role: "Assistant Project Manager, Data Science Lead",
    name: "Oscar Syu",
    team_ids: [1, 5],
  },
  {
    user_id: 27,
    role: "UX/UI Design Lead",
    name: "Ramya Rajasekaran",
    team_ids: [2],
  },
  {
    user_id: 26,
    role: "UX/UI Design",
    name: "Ruby Hirsch",
    team_ids: [2],
  },
  {
    user_id: 28,
    role: "UX/UI Design",
    name: "Sampada Samaka",
    team_ids: [2],
  },
  {
    user_id: 29,
    role: "UX/UI Design",
    name: "Jaswanth Reddy Shamakkagari",
    team_ids: [2],
  },
  {
    user_id: 7,
    role: "Front End Engineering Lead",
    name: "Nick Visutsithiwong",
    team_ids: [3],
  },
  {
    user_id: 30,
    role: "Front End Engineer",
    name: "Zaima Choudhry",
    team_ids: [3],
  },
  {
    user_id: 31,
    role: "Front End Engineer",
    name: "Nutan Pandeya",
    team_ids: [3],
  },
  {
    user_id: 42,
    role: "Front End Engineer",
    name: "Kevin Szeto",
    team_ids: [3],
  },
  {
    user_id: 33,
    role: "Back End Engineering Lead",
    name: "Newton Chung",
    team_ids: [4],
  },
  {
    user_id: 34,
    role: "Back End Engineer",
    name: "Quinn Redwoods",
    team_ids: [4],
  },
  {
    user_id: 35,
    role: "Back End Engineer",
    name: "Brendan Wong",
    team_ids: [4],
  },
  {
    user_id: 36,
    role: "Back End Engineer",
    name: "Neelansh Khare",
    team_ids: [4],
  },
  {
    user_id: 39,
    role: "Data Science",
    name: "Amreen Kaur",
    team_ids: [5],
  },
  {
    user_id: 40,
    role: "Data Science",
    name: "Shilpa Dhananjayan",
    team_ids: [5],
  },
  {
    user_id: 41,
    role: "Data Science",
    name: "Philippe Marchand",
    team_ids: [5],
  },
  {
    user_id: 37,
    role: "Partnerships",
    name: "Joey Ong",
    team_ids: [6],
  },
];

export const InactiveTeamMembers: TeamMember[] = [
  {
    user_id: 18,
    role: "Partnerships Lead",
    name: "Julia Cordero",
    team_ids: [6],
  },
  {
    user_id: 38,
    role: "Partnerships",
    name: "Chanel Johnson",
    team_ids: [6],
  },
  {
    user_id: 3,
    role: "Product Design Lead",
    name: "Micah Johnson",
    team_ids: [2],
  },
  {
    user_id: 9,
    role: "UX/UI Design Lead",
    name: "Jocelyn Su",
    team_ids: [2],
  },
  {
    user_id: 11,
    role: "UX/UI Design",
    name: "Teresa Yang",
    team_ids: [2],
  },
  {
    user_id: 6,
    role: "UX Writer",
    name: "Nikki Collister",
    team_ids: [2],
  },
  {
    user_id: 4,
    role: "Front End Engineering Lead",
    name: "Svetlana Eliseeva",
    team_ids: [4],
  },
  {
    user_id: 12,
    role: "Front End Engineering Lead",
    name: "Josh van Eyken",
    team_ids: [3],
  },
  {
    user_id: 13,
    role: "Front End Engineer",
    name: "Jobe Abdellah",
    team_ids: [3],
  },
  {
    user_id: 14,
    role: "Front End Engineer",
    name: "Amna Khan",
    team_ids: [3],
  },
  {
    user_id: 15,
    role: "Front End Engineer",
    name: "Diya Baliga",
    team_ids: [3],
  },
  {
    user_id: 32,
    role: "Front End Engineer",
    name: "Jesse Mavi",
    team_ids: [3],
  },
  {
    user_id: 10,
    role: "Back End Engineering Lead",
    name: "Eli Lucherini",
    team_ids: [4],
  },
  {
    user_id: 16,
    role: "Front End Engineer",
    name: "Leah Treidler",
    team_ids: [3],
  },
  {
    user_id: 17,
    role: "Front End Engineer",
    name: "Raymond Yee",
    team_ids: [3, 4],
  },
  {
    user_id: 5,
    role: "Back End Engineering Lead",
    name: "Anna Gennadinik",
    team_ids: [4],
  },
  {
    user_id: 44,
    role: "Back End Engineer",
    name: "Adam Finkle",
    team_ids: [4],
  },
  {
    user_id: 21,
    role: "Data Science, Back End Engineer",
    name: "Lola Jackson",
    team_ids: [4],
  },
  {
    user_id: 8,
    role: "Back End Engineer, Data Science",
    name: "Jiang John",
    team_ids: [4, 5],
  },
  {
    user_id: 19,
    role: "Full Stack Engineer",
    name: "Vincent Shuali",
    team_ids: [3, 4],
  },
  {
    user_id: 20,
    role: "Back End Engineer",
    name: "Neeraj Lad",
    team_ids: [4],
  },
  {
    user_id: 22,
    role: "Data Science",
    name: "Peter Cuddihy",
    team_ids: [5],
  },
  {
    user_id: 24,
    role: "Back End Engineer",
    name: "Santosh Gummidipundi",
    team_ids: [4],
  },
  {
    user_id: 23,
    role: "Back End Engineer",
    name: "Anastasia Belenkii",
    team_ids: [4],
  },
  {
    user_id: 25,
    role: "Back End Engineer",
    name: "Carly Thomas",
    team_ids: [4],
  },
  { user_id: 43, role: "Data Science", name: "Hrishik Guha", team_ids: [5] },
];

export const PillData = [
  {
    name: "softStory",
    trueData: "Non-Compliant",
    falseData: "Compliant",
    noData: "No Data",
  },
  {
    name: "liquefaction",
    trueData: "Susceptible",
    falseData: "Not in Zone",
    noData: "No Data",
  },
  {
    name: "tsunami",
    trueData: "In Zone",
    falseData: "Not in Zone",
    noData: "No Data",
  },
];

export const LayerIds = ["softStoriesLayer", "seismicLayer", "tsunamiLayer"];
